import { Component, OnInit } from '@angular/core';
import { ClinicProductService } from 'src/app/_services/clinic-product.service';
import { MessageService } from 'primeng/api';
import { ClinicService } from 'src/app/_services/clinic.service';

@Component({
  selector: 'app-head-office-home',
  templateUrl: './head-office-home.component.html',
  styleUrls: ['./head-office-home.component.scss'],
})
export class HeadOfficeHomeComponent implements OnInit {
  order_count: number = 0;
  sales_orders: any[] = [];
  loadingPage: boolean = true;
  nurse_count: number = 0;
  clinic_count: number = 0;
  order: any;

  constructor(
    private clinicProductService: ClinicProductService,
    private messageService: MessageService,
    private clinicService: ClinicService
  ) {}

  ngOnInit(): void {
    this.loadDashboardData();
    this.loadNurses();
    this.loadClinics();
    this.loadSalesOrders();
  }

  loadDashboardData(): void {
    this.loadingPage = true;
    this.clinicProductService.getSalesOrderCount().subscribe(
      (data: any) => {
        console.log('Sales Order Count:', data);
        this.sales_orders = data.body.data;
        this.order_count = data.body.count;
        this.loadingPage = false;
      },
      (error: any) => {
        console.error('Error fetching clinic orders:', error);
        this.loadingPage = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load dashboard data',
          key: 'main',
        });
      }
    );
  }

  loadSalesOrders(): void {
    this.clinicProductService.getOrders().subscribe((data: any) => {
      this.order = data.body.data;
    })
  }

  loadNurses(): void {
    this.clinicService.getAdminNurses().subscribe(
      (data: any) => {
        console.log('Nurses:', data);
        this.loadingPage = false;
        this.nurse_count = data.body.count;
      },
      (error: any) => {
        console.error('Error fetching nurses:', error);
        this.loadingPage = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load nurses',
          key: 'main',
        });
      }
    );
  }

  loadClinics(): void {
    this.clinicService.getClinics().subscribe(
      (data: any) => {
        console.log('Clinics:', data);
        this.clinic_count = data.body.count;
      },
      (error: any) => {
        console.error('Error fetching clinics:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load clinics',
          key: 'main',
        });
      }
    );
  }

  refreshData(): void {
    this.loadDashboardData();
  }
}
